export default "__VITE_PUBLIC_ASSET__3af2aa27__"